/**
 * Actionable link types associated with a product.
 * @readonly
 * @enum {string}
 */
const types = {
  /** The link points to a related product category. */
  category: 'category',
};

/**
 * Display types triggered when a product action occurs.
 * @readonly
 * @enum {string}
 */
const displayTypes = {
  /** Displays products in a grid layout. */
  grid: 'GRID',
};

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    actionableLinkConst: Object.freeze({
      displayTypes,
      types,
    }),
  }),

  computed: {
    actionableLinkType() {
      return this.product.bylActionableLink?.type;
    },
    actionableLinkButtonObject() {
      return this.product.bylActionableLink?.data?.buttonElement;
    },
    actionableLinkDisplayObject() {
      return this.product.bylActionableLink?.data?.displayElement;
    },
  },
};
